import React, { useState } from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { TYPOGRAPHY_SIZE } from 'mm-theme-configuration/dist/consts';
import { generateLinkStyleFromTheme, TextLinkComponent } from '../../../partials/link/TextLink';
import { MEDIA_BREAKPOINTS } from '../../../../mediaQueries.const';
import { Span, semanticCSS } from '../../../../typography/semanticTags';
import { SemanticTagThemeProps, FontSizesStyles, getStyleBySize } from '../../../../typography/semanticTags/semanticTags.utils';
import { BaseUnit } from '../../../../theming/baseUnitDefinition';

interface MenuLinkProps extends SemanticTagThemeProps {
  linkColor: string
  hoverColor: string
  activeColor: string
  href: string
  text: string
  baseUnit: BaseUnit
  isActive: boolean
  configThemeKey?: string
}

const getWrapperStyle = (baseUnit: BaseUnit) => StyleSheet.create({
  wrapper: {
    [MEDIA_BREAKPOINTS.LARGE]: {
      padding: `${baseUnit / 4}px 0`,
    },
  },
});

const getContentStyle = (configThemeKey: string | undefined, hovering: boolean, isActive: boolean, fontSizesStyles: FontSizesStyles) => {
  switch (configThemeKey) {
    case 'editionsMenu': {
      const fontSizesForHovering = { fontSizeSmall: TYPOGRAPHY_SIZE.BIGGER, fontSizeMedium: TYPOGRAPHY_SIZE.BIGGER, fontSizeLarge: TYPOGRAPHY_SIZE.BIGGER };
      const fontSizesForNotHovering = { fontSizeSmall: TYPOGRAPHY_SIZE.NORMAL, fontSizeMedium: TYPOGRAPHY_SIZE.NORMAL, fontSizeLarge: TYPOGRAPHY_SIZE.NORMAL };
      return getStyleBySize(fontSizesStyles, hovering ? fontSizesForHovering : fontSizesForNotHovering);
    }
    case 'moreLinks': {
      const fontSizesForActive = { fontSizeSmall: TYPOGRAPHY_SIZE.BIGGER, fontSizeMedium: TYPOGRAPHY_SIZE.BIGGER, fontSizeLarge: TYPOGRAPHY_SIZE.BIGGER };
      const fontSizesForNotActive = { fontSizeSmall: TYPOGRAPHY_SIZE.NORMAL, fontSizeMedium: TYPOGRAPHY_SIZE.NORMAL, fontSizeLarge: TYPOGRAPHY_SIZE.NORMAL };
      return getStyleBySize(fontSizesStyles, isActive ? fontSizesForActive : fontSizesForNotActive);
    }
    default: return getStyleBySize(fontSizesStyles, { fontSizeSmall: TYPOGRAPHY_SIZE.NORMAL, fontSizeMedium: TYPOGRAPHY_SIZE.NORMAL, fontSizeLarge: TYPOGRAPHY_SIZE.NORMAL });
  }
};

export const DropDownMenuLink: React.FunctionComponent<MenuLinkProps> = props => {
  const { linkColor, hoverColor, activeColor, href, text, baseUnit, isActive, configThemeKey, fontSizesStyles } = props;
  const [hovering, setHovering] = useState(false);
  const wrapperStyle = getWrapperStyle(baseUnit);
  const contentStyle = getContentStyle(configThemeKey, hovering, isActive, fontSizesStyles);
  const linkStyle = generateLinkStyleFromTheme({
    idleColor: isActive ? activeColor : linkColor,
    activeStateColor: activeColor,
    hoverStateColor: isActive ? activeColor : hoverColor,
  }, { width: '100%' });

  return (
    <li onMouseEnter={() => setHovering(true)} onMouseLeave={() => setHovering(false)} className={css(wrapperStyle.wrapper)}>
      <TextLinkComponent href={href} linkStyle={linkStyle}>
        <Span styles={semanticCSS(contentStyle)}>{text}</Span>
      </TextLinkComponent>
    </li>
  );
};
